import { addApolloState, initializeApollo } from 'util/apolloClient'
import ReactMarkdown from 'react-markdown'
import {
  FindPageBySlugDocument,
  FindAllPagesDocument,
} from 'graphql/generated/types'
import ApplicationLayout from 'layouts/application'
import Head from 'next/head'
import { Col, Row, Typography } from 'antd'

const { Title } = Typography

const PageBody = (props) => {
  const { pages } = props
  return (
    <div>
      {pages && (
        <ReactMarkdown>
          {`${pages.data[0].attributes.description}`}
        </ReactMarkdown>
      )}
    </div>
  )
}

const PageDescription = (props) => {
  const { data } = props
  const {
    pages,
    all_brokers: { data: allBrokers },
    nav_calculators: { data: navCalculators },
    all_pages: { data: allPages },
  } = data

  const { title: meta_title } = pages.data[0].attributes
  const meta_desc = `${meta_title} - Fintrakk`

  return (
    <ApplicationLayout
      allBrokers={allBrokers}
      navCalculators={navCalculators}
      allPages={allPages}
    >
      <Head>
        <title>{meta_title}</title>
        <meta name="description" content={meta_desc} />
      </Head>
      <Row className="page">
        <Title className="title-wrapper">{meta_title}</Title>
        <Row className="row-wrapper">
          <Col span={24}>
            <PageBody pages={pages} />
          </Col>
        </Row>
      </Row>
    </ApplicationLayout>
  )
}

export default PageDescription

export async function getStaticPaths() {
  const apolloClient = initializeApollo()
  const queryResults = await apolloClient.query({
    query: FindAllPagesDocument,
  })
  const results = queryResults.data.pages.data
  const paths = results.map((entry) => ({
    params: { slug: entry.attributes.slug },
  }))
  return { paths, fallback: false }
}

export async function getStaticProps({ params }) {
  const apolloClient = initializeApollo()
  const { slug } = params

  const queryResults = await apolloClient.query({
    query: FindPageBySlugDocument,
    variables: { slug },
  })

  const { data } = queryResults

  return addApolloState(apolloClient, {
    props: { data },
  })
}
